var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBusiness(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 48,
    viewBox: "0 0 48 48",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b06550;}.cls-2{fill:#c8785c;}.cls-3{fill:#ecf0f1;}.cls-4{fill:#4c5665;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Business case",
    id: "Business_case"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2,21H46a0,0,0,0,1,0,0V45a2,2,0,0,1-2,2H4a2,2,0,0,1-2-2V21A0,0,0,0,1,2,21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48,25c-7,8-39,8-48,0V11H48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48,25c-7,8-39,8-48,0V11H48Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    height: 6,
    rx: 1,
    ry: 1,
    width: 8,
    x: 20,
    y: 28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M13.936,8.068l-4-.118A6.958,6.958,0,0,1,17.062,1h14a6.8,6.8,0,0,1,7,7h-4a2.824,2.824,0,0,0-3-3h-14A2.971,2.971,0,0,0,13.936,8.068Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47,8v3H0V9A1,1,0,0,1,1,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47,8h0a1,1,0,0,1,1,1v2a0,0,0,0,1,0,0H46a0,0,0,0,1,0,0V9A1,1,0,0,1,47,8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 7,
    rx: 1,
    ry: 1,
    width: 18,
    x: 15,
    y: 15
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBusiness);
export default __webpack_public_path__ + "static/media/icon-business.9f8577aa572896b99c13bf0e0203db73.svg";
export { ForwardRef as ReactComponent };